import { request } from './client';
import type { MapKpi } from './reports';

/**
 * Which figures the map shows when somebody points at a store.
 *
 * Saved whole, like the mail lists: the screen shows all four with their ticks and their
 * order, and saving one at a time would let somebody leave two figures claiming the same
 * position.
 */

const base = '/api/v1/parameters/map-kpis';

export interface MapKpiSetting {
  kpi: MapKpi;
  isEnabled: boolean;
  order: number;
}

export const mapSettings = {
  /** All four, including the ones switched off — this screen is where they come back. */
  list: () => request<MapKpiSetting[]>(base),

  save: (kpis: MapKpiSetting[]) =>
    request<MapKpiSetting[]>(base, { method: 'PUT', body: JSON.stringify({ kpis }) }),
};
